import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App'; // Adjust the path if App.js is in a different location
import './index.css'; // Import your global styles (optional)
import * as Sentry from "@sentry/react";

const container = document.getElementById('root'); // Make sure this matches the div in index.html
const root = createRoot(container); // React 18's createRoot API
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  sendDefaultPii: true,
  environment: import.meta.env.VITE_ENV,
});

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

